import type { AudioControl } from "./use-game-audio";
import "./audio-settings.css";

export function AudioSettings({ audio }: { audio: AudioControl }) {
  const { settings, status, change } = audio;
  return (
    <section className="audio-settings" data-audio-settings aria-label="Звук">
      <div className="audio-heading">
        <span><b>ЗВУК</b></span>
        <button type="button" aria-pressed={settings.muted}
          aria-label={settings.muted ? "Включить звук" : "Выключить звук"}
          onClick={() => change({ ...settings, muted: !settings.muted })}>
          {settings.muted ? "Выключен" : "Включён"}
        </button>
      </div>
      <label>
        <span>Музыка <output>{Math.round(settings.music * 100)}%</output></span>
        <input type="range" min="0" max="100" step="1" aria-label="Громкость музыки"
          value={Math.round(settings.music * 100)} disabled={status === "unavailable"}
          onChange={event => change({ ...settings, music: Number(event.currentTarget.value) / 100 })} />
      </label>
      <label>
        <span>Эффекты и интерфейс <output>{Math.round(settings.effects * 100)}%</output></span>
        <input type="range" min="0" max="100" step="1" aria-label="Громкость эффектов"
          value={Math.round(settings.effects * 100)} disabled={status === "unavailable"}
          onChange={event => change({ ...settings, effects: Number(event.currentTarget.value) / 100 })} />
      </label>
      {status === "unavailable" && <p role="status">Звук недоступен в этом браузере.</p>}
      {status === "waiting" && <p>Звук начнётся после нажатия в игре.</p>}
    </section>
  );
}
